import {
  GET_SESSION,
  GET_SESSION_SUCCESS,
  GET_SESSION_UNAVAILABLE,
  GET_SETTINGS,
  GET_SETTINGS_SUCCESS,
  GET_SETTINGS_FAILURE,
  LOGIN,
  LOGOUT,
  API_ERROR
} from "./actionTypes"

export const getSession = () => {
  return {
    type: GET_SESSION,
    payload: [],
  }
}

export const getSessionSuccess = session => {
  return {
    type: GET_SESSION_SUCCESS,
    payload: session,
  }
}

// The API could not confirm the session at all (no answer, timeout or 5xx):
// reason is "timeout" | "network" | "server". Not a signed-out session.
export const getSessionUnavailable = reason => {
  return {
    type: GET_SESSION_UNAVAILABLE,
    payload: reason,
  }
}

export const login = values => {
  return {
    type: LOGIN,
    payload: values,
  }
}

export const logout = values => {
  return {
    type: LOGOUT,
    payload: values,
  }
}

export const getSettings = () => {
  return {
    type: GET_SETTINGS,
    payload: [],
  }
}

export const getSettingsSuccess = settings => {
  return {
    type: GET_SETTINGS_SUCCESS,
    payload: settings,
  }
}

export const getSettingsFailure = error => {
  return {
    type: GET_SETTINGS_FAILURE,
    payload: error,
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}
